module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('h2', [_vm._v("Stale Requests")]), _vm._v(" "), _c('el-alert', {
    attrs: {
      "title": "Note:",
      "description": "These are request steps with no files uploaded.",
      "show-icon": "",
      "closable": false
    }
  }), _vm._v(" "), _c('data-table', {
    attrs: {
      "title": "Stale Requests",
      "url": '/report/requests/stale' + (this.isTelco() ? '/' + this.org().id : ''),
      "show-search": false,
      "fields": ['actionType', 'fileTitle', 'siteName', 'requestor', 'email', 'phone', 'targetDate', 'updated_at']
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4151b5fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/requests/StaleRequestReport.vue
// module id = 1533
// module chunks = 0